import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BreadcrumbItem } from '@/types/menu';

export type BreadcrumbState = {
  items: BreadcrumbItem[];
};

export const breadcrumbInitialState: BreadcrumbState = {
  items: [],
};

const slice = createSlice({
  name: 'breadcrumb',
  initialState: breadcrumbInitialState,
  reducers: {
    setBreadcrumbItemsAction(state, { payload }: PayloadAction<BreadcrumbItem[]>) {
      state.items = payload;
    },
    clearBreadcrumbItemsAction(state) {
      state.items = [];
    },
  },
});

export const { setBreadcrumbItemsAction, clearBreadcrumbItemsAction } = slice.actions;
export default slice.reducer;
